import getDataLayer from './getDataLayer';
import { DlEcommerceEvents } from './constant';

export const DL_SignUp = (method: string) => {
  getDataLayer().push({
    event: DlEcommerceEvents.SIGN_UP,
    ecommerce: {
      method,
    },
  });
};
